import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Icon from '../../../../../components/Icon';
import Dialog from '../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../reusables/Dialog/extras/caption';

const ModalConfirmDetails = styled.div`
  padding: 16px 32px 0 32px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ModalConfirmDetail = styled.div`
  display: flex;
  align-items: center;

  > cc-icon {
    margin-right: 10px;
    color: #161d1f;
  }

  > span {
    font-size: 14px;
    color: #161d1f;
  }
`;

interface IProps {
  campus?: any;
  date?: any;
  duration?: any;
  hour?: any;
  library?: any;
  show: boolean;
  resourceType: { isTablet: boolean; isComputer: boolean };
  handlerClose: () => void;
  handlerConfirm: () => void;
}

const ModalConfirm = ({
  campus,
  date,
  duration,
  hour,
  library,
  show,
  resourceType,
  handlerClose,
  handlerConfirm
}: IProps) => {
  const handlerHourRange = (hourData?: any, durationData?: any) => {
    let result = '';

    if (hourData && durationData) {
      const start = moment(hourData.timestamp).utc();
      const end = moment(hourData.timestamp)
        .add(durationData.hour, 'hours')
        .utc();
      result = `${start.format('HH:mm')} a ${end.format('HH:mm')}`;
    }

    return result;
  };

  return (
    <Dialog
      handlerClose={() => handlerClose()}
      maxWidth="360px"
      show={show}
      textButtonA="Sí, reservar"
      textButtonB="Cancelar"
      zIndex={1000}
      handlerButtonA={() => handlerConfirm()}
      handlerButtonB={() => handlerClose()}
    >
      {resourceType.isTablet && (
        <DialogExtraCaption title="¿Deseas realizar esta reserva de tablet?" />
      )}
      {resourceType.isComputer && (
        <DialogExtraCaption title="¿Deseas realizar esta reserva de computadora?" />
      )}
      <ModalConfirmDetails>
        <ModalConfirmDetail>
          <Icon name="map-pin" size={14} />
          <span>Campus {campus ? campus.name : ''}</span>
        </ModalConfirmDetail>
        <ModalConfirmDetail>
          <Icon name="book-open" size={14} />
          <span>{library ? library.name : ''}</span>
        </ModalConfirmDetail>
        <ModalConfirmDetail>
          <Icon name="calendar" size={14} />
          <span>{date ? date.name : ''}</span>
        </ModalConfirmDetail>
        <ModalConfirmDetail>
          <Icon name="clock" size={14} />
          <span>{handlerHourRange(hour, duration)}</span>
        </ModalConfirmDetail>
      </ModalConfirmDetails>
    </Dialog>
  );
};

export default ModalConfirm;
